import React from "react";
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { PageWrapper } from "../../../components";

import VideoPoster from '../../../video/poster.png';
import Video540 from '../../../video/AutoAxess_540.mp4';

const IntroSectionHolder = styled.section`
  padding: 40px 0;

  .button-primary {
    &.left {
      display: none;
    }

    &.right {
      margin-top: 40px;
    }
  }

  @media only screen and (min-width: 1026px) {
    padding: 112px 40px 126px;

    .button-primary {
      &.left {
        display: block;
      }

      &.right {
        display: none;
      }
    }
  }
`;

const StyledHeading = styled.h1`
  margin: 0 0 10px;
  color: #424141;
  font-weight: 500;
  font-size: 24px;
  text-transform: uppercase;

  @media only screen and (min-width: 1026px) {
    margin: 0 0 23px;
    font-size: 36px;
    line-height: 42px;
  }
`;

const StyledDescription = styled.p`
  margin-bottom: 22px;
  color: #54607D;
  font-size: 14px;
  line-height: 24px;
  
  span {
    display: block;
  }

  @media only screen and (min-width: 1026px) {
    margin-bottom: 48px;
    font-size: 18px;
  }
`;

const VideoHolder = styled.div`
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25);

  video {
    display: block;
  }

  @media only screen and (min-width: 1026px) {
    margin-left: 70px;
  }
`;

const IntroSection = () => (
  <PageWrapper>
    <IntroSectionHolder>
      <Grid container>
        <Grid item xs={12} md={5}>
          <StyledHeading>The online wholesale auto auction built by car guys for car guys</StyledHeading>
          <StyledDescription>
            AutoAxess offers less frustration, a wide variety of local vehicles, and the lowest fees in the market…
            <span>period.</span>
          </StyledDescription>
          <Link className="button-primary left" to='/register'>Sign Up</Link>
        </Grid>
        <Grid item xs={12} md={7}>
          <VideoHolder>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video
              controls
              width="100%"
              poster={VideoPoster}
            >
              <source src={Video540} type="video/mp4" />
            </video>
          </VideoHolder>
          <Link className="button-primary right" to='/register'>Sign Up</Link>
        </Grid>
      </Grid>
    </IntroSectionHolder>
  </PageWrapper>
);

export default IntroSection;
